<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftWizard from '../../../../shift_wizard/components/ShiftWizard.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <ShiftWizard />
</template>